import { useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { Card } from "@/components/ui/card";
import { useAdminFetch, TabState, Stat } from "../useAdminFetch";

export default function UsageTab({ cid }) {
  const [days, setDays] = useState(30);
  const { data, error, loading } = useAdminFetch(`/admin/companies/${cid}/usage`, { days });
  return (
    <Card className="p-4 border-slate-200 space-y-4" data-testid="usage-tab">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-sm text-slate-600" data-testid="usage-range">{data ? `${data.range.from} → ${data.range.to} (UTC)` : ""}</div>
        <div className="flex gap-1 p-1 bg-slate-100 rounded-lg">
          {[7, 30, 90].map((d) => (
            <button key={d} onClick={() => setDays(d)} data-testid={`usage-days-${d}`} className={`px-3 py-1 text-xs rounded ${days === d ? "bg-white shadow-sm font-medium" : "text-slate-600"}`}>Last {d} days</button>
          ))}
        </div>
      </div>
      <TabState loading={loading && !data} error={error} testid="usage">
        {data && <>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
            <Stat label="Messages sent" value={data.totals.sent} testid="usage-sent" />
            <Stat label="Messages received" value={data.totals.received} testid="usage-received" />
            <Stat label="New conversations" value={data.totals.conversations} />
            <Stat label="New leads" value={data.totals.leads} />
            <Stat label="New qualified leads" value={data.totals.qualified} />
          </div>
          <div className="h-72">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data.series}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={(d) => d.slice(5)} />
                <YAxis allowDecimals={false} tick={{ fontSize: 10 }} />
                <Tooltip /><Legend />
                <Bar dataKey="sent" fill="#6366f1" name="Sent" />
                <Bar dataKey="received" fill="#10b981" name="Received" />
                <Bar dataKey="conversations" fill="#0ea5e9" name="Conversations" />
                <Bar dataKey="leads" fill="#f59e0b" name="Leads" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>}
      </TabState>
    </Card>
  );
}
